
import { ArrowLeftIcon, ArrowRightIcon, BanIcon, CheckIcon, MailIcon, PhoneIcon } from '@heroicons/react/outline'
import { click } from '@testing-library/user-event/dist/click';
import { Modal, Progress } from 'flowbite-react';
import React from 'react'
import { useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router';
import { toast } from 'react-toastify';
import { ButtonUi, LoadingUi } from '../components/components';
import { TableUi } from '../components/table.ui';
import { privateApi } from '../services/api.interceptor';
import commandeService from '../services/commande.service';
import userServices from '../services/user.services';
import Constants from '../tools/constants.tools';


function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export const getUser = async ({ queryKey }) => {
  const [_, userId] = queryKey
  const { data } = await privateApi.get(`/users/${userId}`)
  return data
}

export const userCmds = async ({ queryKey }) => {
  const [_, userId] = queryKey
  const { data } = await privateApi.get(`/commandes/user_commandes/${userId}`)
  return data
}
const UserInfos = () => {

  const navigate = useNavigate();
  const _param = useParams()

  
  
  const _user = useQuery(['user', _param.id], getUser, {
    select: (data) => { 
      let prix = 0;
      let filter = {
        "_id": data._id,
        "typeAccount": data.typeAccount,
        "matricule": data.matricule,
        "nom": data.nom,
        "prenom": data.prenom,
        "fonction": data.fonction,
        "telephone": data.telephone,
        "email": data.email,
        "monthPrixTotal": 0,
        "mesCommandes":[]
      };
      for (let index = 0; index < data.mesCommandes.length; index++) {
        if(data.mesCommandes[index].status === 'servie'){
          filter.mesCommandes.push(data.mesCommandes[index]);
          filter.monthPrixTotal += data.mesCommandes[index].prix
        }
      }
      return filter;
    }
  });
  const _userCmds = useQuery(['userCmds', _param.id], userCmds, {
    onSuccess: resp => {
      let prix = 0;
      resp?.map(item => {
        if(item.status === 'servie'){
          prix += item.prix 
        }
      })
      setState({...state, allPrixTotal: prix})
    }
  })

  const _userResetCmd = useMutation(userServices.resetCommande, {
    onSuccess: resp => {
      _user.refetch()
      setState({...state, showModal: false})
      toast.success('Tableau de commandes réinitialisé avec succès')
    },
    onError: resp => {
      if(resp?.response?.data?.error){
        toast.error(resp?.response?.data?.error)
      } else
      toast.error("Une erreur inconnue s'est produite")
    },
    onSettled: () => {}
  })


  const COLUMNS = [
    {
      Header: "##",
      accessor: "_id",
    },
    {
      Header: "Image",
      accessor: "image",
      Cell: ({ cell }) => (
        <div className="">
          <img
            className="w-14 h-14 rounded-full bg-gray-100"
            src={Constants.IMAGE_LINK+cell.row.values.image}
          />
        </div>
      ),
    },
    {
      Header: "Plat",
      accessor: "nom",
    },

    {
      Header: "Prix",
      accessor: "prix",
      Cell: ({ cell }) => (
        <div className="bg-blue-500 p-1 rounded-full text-white">{cell.row.values.prix} GNF </div>
      ),
    },
    {
      Header: "Eau",
      accessor: "prixEau",
      Cell: ({ cell }) =>
        cell.row.values.prixEau !== 0 ? (
          <CheckIcon className="h-5 w-5 ml-5 text-white bg-green-400" />
        ) : (
          <BanIcon className="h-5 w-5 ml-5 bg-red-400 text-white" />
        ),
    },
    {
      Header: "Jus",
      accessor: "prixJus",
      Cell: ({ cell }) =>
        cell.row.values.prixJus !== 0 ? (
          <CheckIcon className="h-5 w-5 ml-5 text-white bg-green-400" />
        ) : (
          <BanIcon className="h-5 w-5 ml-5 bg-red-400 text-white" />
        ),
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ cell }) =>
        cell.row.values.status === 'attente' ? (
          <span className="bg-indigo-200 px-2 rounded-lg text-indigo-500 font-semibold p-1">
            préparation
          </span>
        ) : cell.row.values.status === "servie" ? (
          <span className="bg-green-200 px-2 rounded-lg text-green-500 font-semibold p-1">
            servie
          </span>
        ) : (
          <span className="bg-red-200 px-2 rounded-lg text-red-500 font-semibold p-1">
            rejetée
          </span>
        ),
    },
  ];


  const [state, setState] = useState({
    showModal: false,
    tabId: 0,
    allPrixTotal: 0
  })


  return (
    <div className="px-5 bg-white rounded-2xl">
      <div className="flex flex-col pt-2 grid-cols-1 divide-y gap-3">
        <div className="flex items-center gap-3">
          <ArrowLeftIcon 
            className="cursor-pointer text-black h-6 w-6" 
            onClick={() => {
              navigate(-1)
            }}
          />
          <h1 className="text-xl">Information sur l'utilisateur</h1>
        </div>

        {_user.isSuccess && _user.data && (
            <div className='pt-3 grid-cols-1 divide-y gap-3'>
              <div className='pb-3'>
                <div className="flex justify-between">
                  <p className=" font-medium">
                    {_user.data?.prenom.charAt(0).toUpperCase()+_user.data?.prenom.slice(1)+' '+_user.data?.nom}
                  </p>
                  <p className="bg-blue-500 text-white px-3 py-1 rounded-full">{_user.data?.matricule}</p>
                </div>

                <div className="flex gap-2 pt-3">
                  <div className="bg-green-400 p-1 rounded-full">
                    <PhoneIcon className="text-white h-5 w-5"/>
                  </div>
                  <div>
                    <p>Téléphone: {_user.data?.telephone}</p>
                  </div>
                </div>

                <div className="flex gap-2 pt-3">
                  <div className="bg-red-400 p-1 rounded-full">
                    <MailIcon className="text-white h-5 w-5"/>
                  </div>
                  <div>
                    <p>Email: {_user.data?.email}</p>
                  </div>
                </div>
              </div>
              
              <div className=" bg-white shadow-md w-full py-5 px-2 rounded-md">
                <TabCommande
                  changeTab={(v) => {
                    setState({...state, tabId: v, allPrixTotal: 0})
                    _user.refetch();
                    _userCmds.refetch()
                  }}
                  tabIndex={state.tabId}
                />

                {
                  _user.isSuccess && _user.data.mesCommandes.length !== 0 && state.tabId === 0 && 
                    <TableUi columns={COLUMNS} data={_user.data.mesCommandes} colsHidden={["_id"]} />
                }

                {
                  _userCmds.isSuccess && _userCmds.data.length !== 0 && state.tabId === 1 && 
                    <TableUi columns={COLUMNS} data={_userCmds.data} colsHidden={["_id"]} />
                }


                <React.Fragment>
                  <Modal
                    show={state.showModal}
                    size='sm'
                    onClose={() => setState({...state, showModal: false})}>
                    <Modal.Header>Réinitialisation</Modal.Header>
                    <Modal.Body className="space-y-6">
                      <div className="text-gray-600 text-sm">
                        En appliquant cette action, cela vas Réinitialiser les commandes de cet utilisateur
                      </div>
                      <div>
                        <ButtonUi
                          isLoading={_userResetCmd.isLoading}
                          onClick={() => {
                            _userResetCmd.mutate({userId: _user.data?._id})
                          }}
                          bColor='bg-red-600'
                        >Réinitialiser</ButtonUi>
                      </div>
                    </Modal.Body>
                  </Modal>
                </React.Fragment>

                <div className="flex justify-end items-center gap-5">
                  {
                    _user.data?.mesCommandes.length !== 0 && state.tabId === 0 && 
                      <div className='flex gap-2'>
                        <p>Total: </p>
                        <p className=' underline text-blue-600'>{_user.data?.monthPrixTotal} GNF</p>
                      </div>
                  }

                  {
                    _userCmds.data?.length !== 0 && state.tabId === 1 &&
                      <div className='flex gap-2'>
                        <p>Total: </p>
                        <p className=' underline text-blue-600'>{state.allPrixTotal} GNF</p>
                      </div>
                  }

                  {
                    _user.data?.mesCommandes.length !== 0 && state.tabId === 0 &&
                      <button
                        onClick={() => {
                          setState({...state, showModal: true})
                        }}
                        className="flex justify-center mt-3 px-3 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-500 focus:outline-none"
                      >Réinitialiser</button>
                  }
                </div>
              </div>
            </div>
          )
        }
    </div>
    </div>
  )

}

export default UserInfos



const TabCommande = ({changeTab, tabIndex = 0}) => {

  const tabs = [
    { id: 0, name: 'Commandes du mois', href: '#' },
    { id: 1, name: 'Historiques de toutes les commandes', href: '#' },
  ]


  return (
    <div>
      <div className="hidden sm:block">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-8" aria-label="Tabs">
            {tabs.map((tab) => (
              <a
                key={tab.name}
                href={tab.href}
                className={classNames(
                  tab.id === tabIndex
                    ? 'border-indigo-500 text-indigo-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                  'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm'
                )}
                aria-current={tab.current ? 'page' : undefined}
                onClick={() => changeTab(tab.id)}
              >
                {tab.name}
              </a>
            ))}
          </nav>
        </div>
      </div>
    </div>
  )
}

